import type { collectionMappingType } from '@adornis/versioned-entity/server/change-stream.js';
import { Organization } from '@saraa/organizations/entities/Organization.js';
import { TemplateField } from '@saraa/template-fields/entities/TemplateField.js';
import { Template } from '@saraa/templater/entities/Template.js';

const ENTITY_VERSIONED_COLLECTION_NAME = 'versions';

export const versionsCollectionNameMapping: collectionMappingType = {
  [TemplateField._collectionName]: {
    versionedCollectionName: ENTITY_VERSIONED_COLLECTION_NAME,
  },
  [Template._collectionName]: {
    versionedCollectionName: ENTITY_VERSIONED_COLLECTION_NAME,
  },
  [Organization._collectionName]: {
    versionedCollectionName: ENTITY_VERSIONED_COLLECTION_NAME,
  },
};
